module.exports = __webpack_public_path__ + "static/media/Dosis-ExtraLight.18640b62.ttf";